import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout4';
import PostCard from '../components/post-card/post-card';
import SEO from '../components/seo';
import { TagPostsWrapper, TagPageHeading, TagName } from './templates.style';

const Tags = ({ pageContext, data }: any) => {
  const { tag } = pageContext;
  const { edges, totalCount } = data.allMarkdownRemark;

  return (
    <Layout>
      <SEO title={tag} description={`A collection of ${totalCount} post`} />

      <TagPostsWrapper>
        <TagPageHeading>
          <TagName>{tag}</TagName>
          {/* {`全部で ${totalCount} 項目あります`} */}
        </TagPageHeading>
        <hr/>
        <br/>
        {edges.map(({ node, index }: any) => (
          <PostCard
            key={node.fields.slug}
            title={node.frontmatter.title}
            url={node.fields.slug}
            description={node.frontmatter.description || node.excerpt}
            date={node.frontmatter.date}
            tags={node.frontmatter.tags}
            sdgs_no={node.frontmatter.sdgs_no}
            honbun={node.frontmatter.honbun}
            no={node.frontmatter.no}
            height_name={node.frontmatter.height_name}
            color_name={node.frontmatter.color_name}
            title_height_name={node.frontmatter.title_height_name}
            title_color_name={node.frontmatter.title_color_name}
            try={node.frontmatter.try}
          />
        ))}
      </TagPostsWrapper>
    </Layout>
  );
};

export default Tags;

export const pageQuery = graphql`
  query($tag: String) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          excerpt(pruneLength: 300)
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD [<span>] MMMM [</span>]")
            title
            tags
            description
            sdgs_no
            honbun
            no
            height_name
            color_name
            title_height_name
            title_color_name
            try
          }
        }
      }
    }
  }
`;
